/**
 * Meta Pixel utility for DermaLipo Phoenix
 * Pixel ID: 6810483222354785
 *
 * LANDING ARCHETYPE: Pure lead generation (no e-commerce, no checkout).
 * Optimized for Meta "Website Lead" campaign objective.
 *
 * 3-event funnel (no noise):
 *   1. PageView          → auto on load            (audiences + lookalikes)
 *   2. InitiateCheckout  → reaches form section    (retargeting intent)
 *   3. Lead              → submits GHL form        (THE conversion)
 *
 * Configure Lead as your top Priority Event in Aggregated Event Measurement.
 */

export const META_PIXEL_ID = '6810483222354785'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

// UUID v4 for event deduplication (used when you later add Conversions API server-side)
export function generateEventId(): string {
  if (
    typeof crypto !== 'undefined' &&
    typeof (crypto as any).randomUUID === 'function'
  ) {
    return (crypto as any).randomUUID()
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export function initMetaPixel() {
  if (typeof window === 'undefined') return
  if (initialized) return
  if (window.fbq) {
    initialized = true
    return
  }

  /* eslint-disable */
  ;(function (f: any, b, e, v, n: any, t: any, s: any) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = !0
    t.src = v
    s = b.getElementsByTagName(e)[0]
    s.parentNode.insertBefore(t, s)
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
    null,
    null,
    null,
  )
  /* eslint-enable */

  window.fbq('init', META_PIXEL_ID)
  window.fbq('track', 'PageView')
  initialized = true
}

function trackEvent(
  eventName: string,
  params?: Record<string, any>,
  options?: { eventID?: string },
) {
  if (typeof window === 'undefined' || !window.fbq) return
  const fullParams = {
    ...(params || {}),
    event_source_url:
      typeof window !== 'undefined' ? window.location.href : undefined,
  }
  if (options?.eventID) {
    window.fbq('track', eventName, fullParams, { eventID: options.eventID })
  } else {
    window.fbq('track', eventName, fullParams)
  }
}

/**
 * Fired when the user reaches the consultation form section.
 * Best signal for retargeting "interested but didn't convert" audiences.
 */
export function trackInitiateCheckout(params?: Record<string, any>) {
  trackEvent('InitiateCheckout', {
    content_name: 'Reached Consultation Form',
    content_category: 'Body Contouring',
    currency: 'USD',
    value: 250,
    ...params,
  })
}

/**
 * THE conversion event. Fires only on real GHL form submission.
 * Set as Priority Event #1 in Aggregated Event Measurement.
 */
export function trackLead(params?: Record<string, any>) {
  const eventID = generateEventId()
  trackEvent(
    'Lead',
    {
      content_name: 'Lipolaser Consultation Request',
      content_category: 'Body Contouring',
      currency: 'USD',
      value: 250,
      ...params,
    },
    { eventID },
  )
  if (typeof console !== 'undefined') {
    console.log('[Meta Pixel] Lead fired', { eventID, params })
  }
}
